/**
 * Copy text to clipboard with fallback for iframe contexts
 * where the Clipboard API is blocked by permissions policy.
 */
export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Fallback: execCommand for iframes without clipboard permission
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      return true;
    } catch {
      console.error("Failed to copy to clipboard");
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
}
